// Utilitários para evitar repetição de código no sistema 3DS

/**
 * Mascara um token mostrando apenas os primeiros 6 e últimos 4 caracteres
 */
export const maskToken = (token: string): string => {
  return `${token.slice(0, 6)}...${token.slice(-4)}`;
};

/**
 * Mascara um número de cartão mostrando apenas os últimos 4 dígitos
 */
export const maskCardNumber = (cardNumber: string): string => {
  return cardNumber.replace(/\d(?=\d{4})/g, '*');
};

/**
 * Log padronizado para environment do 3DS
 */
export const logEnvironment = (context: string, environment: string, source: string = 'backend') => {
  console.log(`🌍 Frontend 3DS - ${context}:`, { environment, source });
};
